import React from 'react';
import { GenericDownloadHandler } from './GenericDownloadHandler';

interface PostPurchaseDownloadHandlerProps {
  sequenceId: string;
  onDownloadComplete?: () => void;
  onError?: (error: string) => void;
  autoStartDownload?: boolean;
}

/**
 * PostPurchaseDownloadHandler - Legacy wrapper for paid sequence downloads
 * 
 * This component now uses the GenericDownloadHandler with paid flow configuration.
 * It maintains backward compatibility with the existing API while leveraging
 * the unified download handler architecture.
 * 
 * @deprecated Consider using GenericDownloadHandler directly for new implementations
 */
export const PostPurchaseDownloadHandler: React.FC<PostPurchaseDownloadHandlerProps> = ({
  sequenceId,
  onDownloadComplete,
  onError,
  autoStartDownload = true,
}) => {
  return (
    <GenericDownloadHandler
      sequenceId={sequenceId}
      onDownloadComplete={onDownloadComplete}
      onError={onError}
      autoStartDownload={autoStartDownload}
      flowType="paid"
      requirePurchaseValidation={true}
      showAddedToDisplayModal={true}
      showConfirmationPage={true}
    />
  );
}; 